import { render, staticRenderFns } from "./NeedsMealsModalTable.vue?vue&type=template&id=1658b36f&scoped=true&lang=pug"
import script from "./NeedsMealsModalTable.vue?vue&type=script&lang=ts"
export * from "./NeedsMealsModalTable.vue?vue&type=script&lang=ts"
import style0 from "./NeedsMealsModalTable.vue?vue&type=style&index=0&id=1658b36f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1658b36f",
  null
  
)

export default component.exports